import * as types from '../constants/ActionTypes';
import { VCS_SLUG } from '../constants/api';
export const initialState = {
    list: {
        bitbucket: {},
        gitlab: {},
        github: {},
    },
    search: '',
};
export default (state = initialState, action) => {
    switch (action.type) {
        case types.ADD_UPDATE_REPOSITORY: {
            return {
                ...state,
                list: {
                    ...state.list,
                    [VCS_SLUG[action.payload.vcs]]: {
                        ...state.list[VCS_SLUG[action.payload.vcs]],
                        [action.payload.fullname]: action.payload,
                    },
                },
            };
        }
        case types.BULK_RELOAD_REPOSITORIES: {
            const list = { ...state.list };
            let repositoryVcs = null;
            action.payload.forEach((repo) => {
                if (!list[VCS_SLUG[repo.vcs]]) {
                    list[VCS_SLUG[repo.vcs]] = {};
                }
                list[VCS_SLUG[repo.vcs]][repo.fullname] = repo;
                repositoryVcs = repo.vcs;
            });
            if (repositoryVcs) {
                const oldRepositoryNames = Object.keys(list[VCS_SLUG[repositoryVcs]]);
                const newRepositories = action.payload;
                const difference = oldRepositoryNames.filter((oldRepoName) => !newRepositories.some((newRepo) => newRepo.fullname === oldRepoName));
                if (difference.length) {
                    difference.forEach((oldRepoName) => {
                        delete list[VCS_SLUG[String(repositoryVcs)]][oldRepoName];
                    });
                }
            }
            return {
                ...state,
                list: list,
            };
        }
        case types.REMOVE_REPOSITORY:
            return {
                ...state,
                list: {
                    ...state.list,
                    [VCS_SLUG[action.payload.vcs]]: {
                        ...state.list[VCS_SLUG[action.payload.vcs]],
                        [action.payload.fullname]: void 0,
                    },
                },
            };
        case types.CLEAR_REPOSITORIES:
            return {
                ...state,
                list: initialState.list,
            };
        case types.SET_REPOSITORY_SEARCH:
            return { ...state, search: action.payload };
        default:
            return state;
    }
};
